/* eslint-disable max-len */
import React from 'react';

function ArrowBackIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_7433_5525)">
                <path
                    d="M10.4938 16C10.7242 16 10.9546 15.912 11.1302 15.7364C11.4818 15.3848 11.4818 14.8152 11.1302 14.4636L4.66622 8L11.1302 1.5364C11.4818 1.1852 11.4818 0.615199 11.1302 0.263599C10.779 -0.0880012 10.2086 -0.0880012 9.85742 0.263599L3.08222 7.0392C2.79822 7.3232 2.64742 7.7052 2.66862 8.0868C2.68742 8.4312 2.84662 8.756 3.10742 8.9864L9.85742 15.7364C10.033 15.912 10.2634 16 10.4938 16Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_7433_5525">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="matrix(1 0 0 -1 0 16)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default ArrowBackIcon;
